import { Component, forwardRef, Input } from '@angular/core';
import {ControlValueAccessor, Validator, FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderService} from '../../../service/order-service';

@Component({
  selector: 'province-select1',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneInputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PhoneInputComponent),
      multi: true
    }
  ]
})
export class PhoneInputComponent implements ControlValueAccessor, Validator {
  provincesList: { id: number, name: string, type: 'central' | 'province' }[] = [
    { id: 1, name: 'Hà Nội', type: 'central' },
    { id: 2, name: 'TP Hồ Chí Minh', type: 'central' },
    { id: 3, name: 'Đà Nẵng', type: 'central' },
    { id: 4, name: 'Lào Cai', type: 'province' },
    { id: 5, name: 'Yên Bái', type: 'province' },
    { id: 6, name: 'Quảng Bình', type: 'province' },
    { id: 7, name: 'Thái Nguyên', type: 'province' },
    { id: 8, name: 'Daklak', type: 'province' },
    { id: 9, name: 'Nghệ An', type: 'province' },
    { id: 10, name: 'Hà Tĩnh', type: 'province' }
  ];
  districtsList:any[] = [];
  communesList:any[] = [];


  private provinceData: { id: number, name: string, type: 'central' | 'province' };

  private selectedData: {provinceId?: number, districtId?: number, communeId?: number};

  private storeData: {provinceId: number, districtId: number, communeId: number};

  onChange: (provinceData: any) => void;
  onTouched: () => void;
  isDisabled: boolean;
  @Input('type') type: 'central' | 'province';


  constructor(
    private orderService: OrderService,
  ) {
    this.getProvinces();
    this.storeData = { provinceId: null, districtId: null, communeId: null };
  }
  getProvinces() {
    this.orderService.getProvincesDisplay().subscribe(res => {
      if (res !== null) {
        this.provincesList = res;
      }
    }, error => {
      console.error("Cannot get list provinces!!!");
    });
  }
  isSelect(provinceId: number): boolean {
    return !this.provinceData ? false : (provinceId === this.provinceData.id);
  }
  isSelectProvince(provinceId: number): boolean {
    return !this.selectedData ? false : (provinceId === this.selectedData.provinceId);
  }
  isSelectDistrict(districtId: number): boolean {
    return !this.selectedData ? false : (districtId === this.selectedData.districtId);
  }
  isSelectCommune(communeId: number): boolean {
    return !this.selectedData ? false : (communeId === this.selectedData.communeId);
  }

  writeValue(obj: any) {
    this.provinceData = obj;
  }

  registerOnChange(fn: (provinceData: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }

  handleOnProvinceChange(e) {
    const provinceId = parseInt(e.target.value);
    //const provinceSelect = this.provincesList.find(province => province.id === provinceId);
    this.storeData.provinceId = provinceId;
    //this.writeValue(provinceSelect);
    this.writeValue(this.storeData);
    this.onChange(this.storeData);

    this.orderService.getDistrictsDisplay(provinceId).subscribe(res => {
      if (res !== null) {
        this.districtsList = res;
        if (this.districtsList.length > 0){
          this.handleOnDistrictChange({target: {value: this.districtsList[0].id}});
        }
      }
    }, error => {
      console.error("Cannot get list districts!!!");
    });
  }
  handleOnDistrictChange(e) {
    const districtId = parseInt(e.target.value);
    this.storeData.districtId = districtId;
    this.writeValue(this.storeData);
    this.onChange(this.storeData);

    this.orderService.getCommunesDisplay(districtId).subscribe(res => {
      if (res !== null) {
        this.communesList = res;
      }
    }, error => {
      console.error("Cannot get list districts!!!");
    });
  }
  handleOnCommuneChange(e) {
    const communeId = parseInt(e.target.value);
    this.storeData.communeId = communeId;
    this.writeValue(this.storeData);
    this.onChange(this.storeData);
  }

  validate(c: FormControl) {
    if (!this.type || !this.provinceData) {
      return null;
    }
    return this.provinceData.type === this.type ? null : {
      type: {
        valid: false,
        actual: c.value
      }
    }
  }
}
